export default __webpack_public_path__ + "static/media/setups-simplification.eba5609d.png";